const HEPSIGLOBAL_URL = 'https://global.hepsiburada.com'
const HEPSIGLOBAL_MODAL_SESSION_STORAGE_KEY = 'hepsiglobalModalDisplayed'

const HEPSIGLOBAL_EVENTS_PROPERTIES = {
  component: 'globalpopup',
  component_detail: 'azerbaycan'
}

const COMPONENT_CLICK_EVENT = {
  CONTINUE_WITH_ACTUAL_SITE: {
    position: 2,
    placement: 'Hepsiburada\'da kalmaya devam et'
  },
  CONTINUE_WITH_GLOBAL_SITE: {
    position: 1,
    placement: 'Hepsiburada Global\'e yönlendir'
  },
  CLOSE_MODAL: {
    position: 0,
    placement: 'closebutton'
  }
}

const HEPSIGLOBAL_MODAL_COUNTRY_CODES = ['Azerbaijan', 'AZ']

export {
  HEPSIGLOBAL_URL,
  HEPSIGLOBAL_EVENTS_PROPERTIES,
  COMPONENT_CLICK_EVENT,
  HEPSIGLOBAL_MODAL_COUNTRY_CODES,
  HEPSIGLOBAL_MODAL_SESSION_STORAGE_KEY
}
